/**
 * @generated SignedSource<<35e577c0f8827a6350f1378f8314325b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RetireTxnDecisionInputObject = {
  decisionIds: ReadonlyArray<string>;
};
export type unprojectedDecisions_RetireMutation$variables = {
  input: RetireTxnDecisionInputObject;
};
export type unprojectedDecisions_RetireMutation$data = {
  readonly retireTxnDecision: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly retiredCount: number;
  } | null | undefined;
};
export type unprojectedDecisions_RetireMutation = {
  response: unprojectedDecisions_RetireMutation$data;
  variables: unprojectedDecisions_RetireMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retiredCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "unprojectedDecisions_RetireMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RetireTxnDecisionMutationPayload",
        "kind": "LinkedField",
        "name": "retireTxnDecision",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "unprojectedDecisions_RetireMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RetireTxnDecisionMutationPayload",
        "kind": "LinkedField",
        "name": "retireTxnDecision",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5b0e5656b740f34981458f99cbe8939b",
    "id": null,
    "metadata": {},
    "name": "unprojectedDecisions_RetireMutation",
    "operationKind": "mutation",
    "text": "mutation unprojectedDecisions_RetireMutation(\n  $input: RetireTxnDecisionInputObject!\n) {\n  retireTxnDecision(input: $input) {\n    retiredCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a86aa415fbf24462f9e42c74a5f84ffd";

export default node;
